import {GruppeMedlemListeModell, SkjermingDetaljerModell, SkjermingModell} from "../tjenester/ressurser/generertNg2HttpKlient";
import {erIkkeTomListe} from "../støttefunksjoner/lister";

export function erSkjermet(potensieltSkjermet: MedSkjerming): boolean {
    return erIkkeTomListe(potensieltSkjermet.skjerming.skjermedeMedlemmerId);
}

export function erIkkeSkjermet(potensieltSkjermet: MedSkjerming): boolean {
    return !erSkjermet(potensieltSkjermet);
}

/** Returnerer informasjon om hvorvidt skjerming er arvet eller ei, for hvert medlem uten tilgang */
export function skjermedeMedlemmerMedArvInfo(skjerming: SkjermingDetaljerModell): MedlemOgArvInfo[] {
    return skjerming.medlemmerUtenTilgang
      .map(medlem => ({medlem: medlem, arvet: harArvetSkjerming(medlem, skjerming)}))
}

/** Returnerer sann dersom angitt medlem er har arvet skjerming */
export function harArvetSkjerming(medlem: GruppeMedlemListeModell, skjerming: SkjermingDetaljerModell): boolean {
    return skjerming.medlemmerIdUtenTilgangTilForelder.includes(medlem.id);
}

/** Returnerer en {@link Skjerming} modell basert på angitt potensielt skjermet entitet */
export function skjermingsinformasjonFor(potensieltSkjermet: MedSkjerming, gruppemedlemmer: GruppeMedlemListeModell[]): Skjerming {
    if (erIkkeSkjermet(potensieltSkjermet)) return ikkeSkjermet();

    const skjermedeMedlemmer = gruppemedlemmer.filter(kandidat =>
      potensieltSkjermet.skjerming.skjermedeMedlemmerId.includes(kandidat.id));
    return {erSkjermet: true, aarsak: potensieltSkjermet.skjerming.aarsak, skjermedeMedlemmer};
}

/** Returnerer en {@link Skjerming} modell som representerer tilstanden 'ingen skjermet' */
export function ikkeSkjermet(): Skjerming {
    return {erSkjermet: false, skjermedeMedlemmer: [], aarsak: ''};
}

/** Returnerer en {@link SkjermingModell} representasjon av angitt skjermingDetaljer. */
export function somSkjermingModell(skjermingDetaljer:  SkjermingDetaljerModell): SkjermingModell {
    return {
        erSkjermetForKallendeBruker: skjermingDetaljer.erSkjermetForKallendeBruker,
        inneholderSkjermedeBarn: skjermingDetaljer.inneholderSkjermedeBarn,
        inneholderBarnSkjermetForKallendeBruker: skjermingDetaljer.inneholderBarnSkjermetForKallendeBruker,
        skjermedeMedlemmerId: skjermingDetaljer.skjermedeMedlemmerId,
        aarsak: skjermingDetaljer.aarsak,
    };
}

export type MedSkjerming = { skjerming: SkjermingModell; }

export interface Skjerming {
    erSkjermet: boolean;
    skjermedeMedlemmer: GruppeMedlemListeModell[];
    aarsak: string;
}

export type MedlemOgArvInfo = { medlem: GruppeMedlemListeModell; arvet: boolean; }
